import {CREATE_TOAST, REMOVE_TOAST_BY_ID} from '../constants';

export default function toasterState(state = [], action) {
    switch (action.type) {
        case CREATE_TOAST:
            if (!action.props.renderContent) {
                return state;
            }

            action.props.id = Date.now();
            return state.concat({props: action.props});
        case REMOVE_TOAST_BY_ID:
            return state.filter(function(el) {
                return el.props.id !== action.payload.id;
            });
        default:
            return state;
    }
}
